let stateFilesList = [];

export const customFile = () => {
  const customFile = document.querySelectorAll('[data-custom-file]');

  if (customFile.length) {
    customFile.forEach((el, i) => {
      el.addEventListener('change', () => {
        if (addFileToInput(el)) {
          buildList(el);
        } else {
          console.log('Erro ao inserir arquivo na lista.');
        }
      });

      // cria o estado responsável pela lista
      stateFilesList.push({ name: el.name, list: [] });
    });
  }

  document.addEventListener('click', function (e) {
    let el = e.target;

    // Se o botão de remover for clicado
    if (el.matches('[data-file-container] span[data-remove]')) {
      const name = el.getAttribute('data-remove');
      const $container = el.closest('[data-file-container]');
      const $input = $container.querySelector('input[type="file"]');

      // Pega a lista do input clicado
      let listFiles = stateFilesList.find(item => item.name == $input.name).list;

      listFiles.filter((item, index) => {
        if (item.name == name) {
          listFiles.splice(index, 1);
          return true;
        }
        return false;
      });

      // Cria uma nova lista dataTransfer
      const transfer = new DataTransfer();
      for (let file of listFiles) {
        transfer.items.add(file);
      }

      // Associa a nova lista ao valor do input
      $input.files = transfer.files;

      // Chama a montagem da lista no html
      buildList($input);
    }
  });
};

// Função responsável por montar a listagem de items abaixo do container
function buildList(input) {
  const $parent = input.closest('[data-file-container]');

  // define o elemento do titulo da lista
  const title = 'Lista de arquivos';
  const $h3 = document.createElement('h3');
  $h3.classList.add('c-list-documents__ttl');
  $h3.innerHTML = title;

  // define o elemento da lista
  const $list = document.createElement('div');
  $list.classList.add('c-list-documents');
  $list.setAttribute('data-uploaded', '');

  // Se o container já existe, remove ele
  let $toRemove = $parent.querySelector('[data-uploaded]');
  $toRemove && $toRemove.parentNode.removeChild($toRemove);

  // Monta o container
  $list.appendChild($h3);

  input.files.forEach((item, key) => {
    // define o elemento com o nome do arquivo
    const $name = document.createElement('span');
    $name.innerHTML = item.name;

    // define o botão de remover
    const $remove = document.createElement('span');
    $remove.classList.add('c-list-documents__remove');
    $remove.setAttribute('data-remove', item.name);

    // define o elemento de item da lista
    const $item = document.createElement('div');
    $item.classList.add('c-list-documents__item');
    $item.appendChild($name);
    $item.appendChild($remove);

    $list.appendChild($item);
  });

  $parent.appendChild($list);
}

function addFileToInput(input) {
  try {
    // Pega a lista do input clicado
    let listFiles = stateFilesList.find(item => item.name == input.name).list;

    if (input.hasAttribute('multiple')) {
      // Verificação pra evitar enviar dois arquivos iguais
      input.files.forEach(file => {
        if (!listFiles.find(f => f.name == file.name)) {
          listFiles.push(file);
        }
      });

      // Cria uma nova lista dataTransfer
      const transfer = new DataTransfer();
      for (let file of listFiles) {
        transfer.items.add(file);
      }

      // Associa a nova lista ao valor do input
      input.files = transfer.files;
    } else {
      const transfer = new DataTransfer();
      transfer.items.add(input.files[0]);

      // Associa a nova lista ao valor do input
      input.files = transfer.files;
    }

    return true;
  } catch {
    return false;
  }
}
